import { render, staticRenderFns } from "./QuestionMultipleChoice.vue?vue&type=template&id=4bcddfa4&scoped=true"
import script from "./QuestionMultipleChoice.vue?vue&type=script&lang=js"
export * from "./QuestionMultipleChoice.vue?vue&type=script&lang=js"
import style0 from "./QuestionMultipleChoice.vue?vue&type=style&index=0&id=4bcddfa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcddfa4",
  null
  
)

export default component.exports